export class CapabilityDropdownFilterConfig {
  static readonly configs = [
    {
      annotation: 'metadata.title',
      label: 'Service/API',
    },
    {
      annotation: 'metadata.annotations.backstage.io/serviceOwner',
      label: 'Service Owner',
    },
    {
      annotation: 'spec.owner',
      label: 'Team',
    },
    // Capability-specific filters
    {
        annotation: 'metadata.annotations.backstage.io/enforcesEntitlements',
        label: 'Enforces Entitlements',
    },
    {
        annotation:'metadata.annotations.backstage.io/entitlementsCatCorpSupport',
        label: 'Entitlements Cat Corp Enabled',
    },
    {
        annotation: 'metadata.annotations.backstage.io/customerMergeFunctionality',
        label: 'Customer Merge Functionality',
    },
    {
        annotation: 'metadata.annotations.backstage.io/localization',
        label: 'Localization',
    },
    {
        annotation: 'metadata.annotations.backstage.io/serviceToServiceCommunicationSupport',
        label: 'Service-to-Service Communication',
    },
    {
        annotation: 'metadata.annotations.backstage.io/forcedFilterSupport',
        label: 'Forced Filter Support',
    },
    {
        annotation: 'metadata.annotations.backstage.io/internalAccessLogging',
        label: 'Internal Access Logging',
    },
    {
        annotation: 'metadata.annotations.backstage.io/catSupportUserActionAuditLogging',   
        label: 'CAT Support User Action Audit Logging',
    },
    {
        annotation: 'metadata.annotations.backstage.io/assetCentric',
        label: 'Asset Centric',
    },
    {
        annotation: 'spec.contractTesting.isEnabled',
        label: 'Contract Testing Enabled',
    },
    {
        annotation: 'spec.contractTesting.listOfApplications',
        label: 'Contract Testing List of Applications',
    },
  ];
}